export class SparkEngine {
    'id';
    'name';
    'eonSparkVersion';
    'maxVcpu';
    'maxMemory';
    'maxStorage';
    'warmCapacity';
    'concurrentJobs';
    'queueTimeout';
    'instanceFamily';
    'dedicatedResources';
    'customImage';
    'awsRuntimeConfig';
    'status';
    'createdAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonSparkVersion",
            "baseName": "eonSparkVersion",
            "type": "EonSparkVersion",
            "format": ""
        },
        {
            "name": "maxVcpu",
            "baseName": "maxVcpu",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxMemory",
            "baseName": "maxMemory",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxStorage",
            "baseName": "maxStorage",
            "type": "number",
            "format": ""
        },
        {
            "name": "warmCapacity",
            "baseName": "warmCapacity",
            "type": "WarmCapacity",
            "format": ""
        },
        {
            "name": "concurrentJobs",
            "baseName": "concurrentJobs",
            "type": "number",
            "format": ""
        },
        {
            "name": "queueTimeout",
            "baseName": "queueTimeout",
            "type": "number",
            "format": ""
        },
        {
            "name": "instanceFamily",
            "baseName": "instanceFamily",
            "type": "string",
            "format": ""
        },
        {
            "name": "dedicatedResources",
            "baseName": "dedicatedResources",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "customImage",
            "baseName": "customImage",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsRuntimeConfig",
            "baseName": "awsRuntimeConfig",
            "type": "SqlEngineAwsRuntimeConfig",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SparkEngineStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SparkEngine.attributeTypeMap;
    }
    constructor() {
    }
}
